<i18n src="@/lang/actions.json"></i18n>
<i18n>
    {
    "en": {
    "periods": "Periods",
    "cross_periods": "Cross periods",
    "start": "Start from",
    "end": "Expire after",
    "table_actions": "Actions",
    "new_period_error_message": "Set the task to the developer “Develop a Mealophone”",
    "table": {
    "col_text_1": "From - To",
    "col_text_2": "Name",
    "col_text_3": "Left"
    }
    },
    "ua": {
    "periods": "Періоди",
    "start": "Діє з",
    "end": "Не діє після",
    "table_actions": "Дії",
    "new_period_error_message": "Set the task to the developer “Develop a Mealophone”"
    },
    "ru": {
    "periods": "Периоды",
    "start": "Действует с",
    "end": "Не действует послуе",
    "table_actions": "Действия",
    "new_period_error_message": "Set the task to the developer “Develop a Mealophone”"
    }
    }
</i18n>

<template>
  <el-col>
    <section-divider icon="el-icon-time" :text="$t('periods')" />
    <el-row>
      <el-table
        :data="s_periods"
        class="services-periods--table"
        :row-class-name="getRowClassName"
      >
        <el-table-column :label="$t('table.col_text_1')">
          <template slot-scope="scope">
            <template v-if="scope.$index != cur_edited_index">
              <span
                class="services-periods--span"
                v-text="scope.row.asString"
              />
            </template>
            <template v-if="scope.$index == cur_edited_index">
              <el-date-picker
                v-model="scope.row.date_start"
                value-format="dd-MM-yyyy"
                format="dd-MM-yyyy"
                type="date"
                _placeholder="Pick a day"
                :style="{ width: '135px' }"
              />
            </template>
          </template>
        </el-table-column>
        <el-table-column :label="$t('table.col_text_2')">
          <template slot-scope="scope">
            <template v-if="scope.$index != cur_edited_index">
              <span
                class="services-periods--span"
                v-text="getPeriodName(scope.row)"
              />
            </template>
            <template v-if="scope.$index == cur_edited_index">
              <el-select
                v-model="scope.row.date_end"
                placeholder="please select period"
              >
                <el-option
                  v-for="p in periods_templates"
                  :key="scope.$index + p.name + p.value"
                  :label="p.name"
                  :value="p.value"
                />
              </el-select>
            </template>
          </template>
        </el-table-column>
        <el-table-column :label="$t('table.col_text_3')">
          <template slot-scope="scope">
            <span
              v-if="scope.$index != cur_edited_index"
              class="services-periods--span"
              v-text="scope.row.endingFromNow"
            />
          </template>
        </el-table-column>
        <el-table-column align="right">
          <template slot="header">
            <el-button
              size="small"
              type="primary"
              v-text="$t('actions.new_period')"
              :disabled="cur_edited_index !== -1"
              @click="handleAddNew"
            />
          </template>
          <template slot-scope="scope">
            <template v-if="scope.$index !== cur_edited_index">
              <el-button
                v-if="scope.row.hasWrongDateFormat"
                type="text"
                size="small"
                :disabled="cur_edited_index != -1"
                v-text="$t('actions.fix')"
                @click="
                  () => {
                    scope.row.fixDateFormat();
                    sharedPeriods._handleSave();
                  }
                "
              />
              <el-button
                type="text"
                size="small"
                :disabled="cur_edited_index != -1"
                v-text="$t('actions.delete')"
                @click="
                  () => {
                    $confirm('Realy want to delete?')
                      .then(() => {
                        s_periods = s_periods.filter(
                          (v, i) => i !== scope.$index
                        );
                        sharedPeriods._handleSave();
                      })
                      .catch(() => {});
                  }
                "
              />
            </template>
            <template v-if="scope.$index == cur_edited_index">
              <el-button
                @click="handleSave"
                type="text"
                size="small"
                :disabled="!scope.row.date_start || !scope.row.date_end"
                v-text="$t('actions.save')"
              />
              <el-button
                type="text"
                size="small"
                @click="
                  () => {
                    s_periods = s_periods.filter((v, i) => i != scope.$index);
                    cur_edited_index = -1;
                  }
                "
                v-text="$t('actions.cancel')"
              />
            </template>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
  </el-col>
</template>

<script>
import { mapState } from "vuex";
import Period from "../../../../store/classes/subClasses/Period";
import moment from "moment";
import SectionDivider from "../SectionDivider";
import SharedPeriods from "../../../../store/classes/SharedPeriods";
import SharedCustomersServices from "../../../../store/classes/SharedCustomersServices";

export default {
  name: "PeriodsSection",
  components: { SectionDivider },
  props: { service: Object },
  data: () => ({
    cur_edited_index: -1
  }),
  created() {
    this.getPeriodsTemplates();
  },
  methods: {
    handleAddNew() {
      this.s_periods.unshift(
        new Period(Object.assign({}, this.new_period_template))
      );
      this.cur_edited_index = 0;
    },
    crutchForSavingNewPeriod() {
      return this.$api.mutate({
        mutation: require("../../../../graphql/services/services_update.graphql"),
        variables: {
          uuid: this.service.uuid,
          update: {
            periods: { periods: this.s_periods },
            amo: this.amo,
            customer: this.customer,
            widget: this.widget
          }
        }
      });
    },
    handleSave() {
      let p = this.s_periods[this.cur_edited_index];
      let tmp = p.date_end;
      let t = p.date_end
        .trim()
        .replace(/^([+-])[\s]+/, "$1")
        .replace(/[\s]{2,}/, " ")
        .split(/\s/);
      if (t.length !== 2) {
        this.$notify({
          type: "error",
          message: this.$t("new_period_error_message")
        });
      }
      this.$log(t);
      let number = t[0].match(/\d+/g)[0] * 1;
      let key = t[1] + (t[1].endsWith("s") ? "" : "s");
      p.period = p.date_end;
      p.date_end = moment(p.date_start, "DD-MM-YYYY")
        .add(number, key)
        .format("DD-MM-YYYY");

      let crosses = this.validatePeriod();
      if (crosses.length != 0) {
        this.$confirm(
          "<span>" + crosses.map(v => v.asString).join("<br>") + "</span>",
          this.$t("cross_periods"),
          { dangerouslyUseHTMLString: true }
        )
          .then(() => {
            return this.sharedPeriods._handleSave().then(() => {
              this.cur_edited_index = -1;
            });
          })
          .catch(() => {
            this.$log("validator FALSE");
            p.date_end = tmp;
          });
        return;
      }
      // this.crutchForSavingNewPeriod()
      //     .then((res) => Object.assign(this.service,
      //         new SharedCustomersServices(res.data.shared_customers_services)
      //     ))
      //     .then(() => { this.cur_edited_index = -1;});
      (this.sharedPeriods instanceof SharedPeriods
        ? this.sharedPeriods._handleSave()
        : this.crutchForSavingNewPeriod().then(res =>
            Object.assign(
              this.service,
              new SharedCustomersServices(res.data.shared_customers_services)
            )
          )
      ).then(() => {
        this.cur_edited_index = -1;
      });
    },
    validatePeriod() {
      let crosses = this.s_periods.filter(
        (v, i) =>
          i !== Number(this.cur_edited_index) &&
          v.dateHaveCrossWith(this.s_periods[this.cur_edited_index])
      );
      this.$log("crosses", crosses);
      return crosses;
    },
    getPeriodsTemplates() {
      if (this.periods_templates_set) {
        return;
      }
      this.$api
        .query({
          query: require("../../../../graphql/periods/periods_list.graphql")
        })
        .then(res => {
          this.$log(res);
          this.$store.commit("periods/setData", res.data.periods);
        });
    },
    getRowClassName({ row, rowIndex }) {
      try {
        let clases = [
          row === this.service.details.period.extra.actualPeriod
            ? "active-period"
            : ""
        ];
        !row.hasWrongDateFormat || clases.push("wrong-date-format");
        return clases.join(" ");
      } catch (e) {}
      return "";
    },
    getPeriodName(period) {
      try {
        return this.periods_templates.find(v => v.value === period.period).name;
      } catch (e) {}
      return "";
    }
  },
  computed: {
    ...mapState({
      periods_templates: state => state.directory_periods_list.data,
      periods_templates_set: state => state.directory_periods_list.set
    }),
    sharedPeriods: {
      get: function() {
        return this.service._embedded.sharedPeriods;
      }
    },
    s_periods: {
      get: function() {
        try {
          return this.sharedPeriods.periods;
        } catch (e) {}
        return [];
      },
      set: function(v) {
        this.sharedPeriods.periods = v;
      }
    }
  }
};
</script>

<style scoped lang="stylus">
.services-periods--table
    & .services-periods--span
        opacity .4

.active-period
    & .services-periods--span
        opacity unset
        font-weight bold
.wrong-date-format
    & .services-periods--span
        color red;
        text-decoration line-through;
</style>
